import { createAction } from 'redux-actions';
export const SET_PASSENGERS = 'EXCHANGE/SET_PASSENGERS';
export const SET_PASSENGER_SELECT = 'EXCHANGE/SET_PASSENGER_SELECT';
export const setPassengers = createAction(SET_PASSENGERS);
export const setPassengerSelect = createAction(SET_PASSENGER_SELECT);
